export type EbomTreePart = {
  id: string
  parentId: string | null
  articleNumber: string
  name: string | null
  position: string | null
}

export type EbomTreeIndex = {
  ancestorIds: (id: string) => string[]
  subtreeIds: (id: string) => Set<string>
}

export function indexEbomTree(parts: EbomTreePart[]): EbomTreeIndex {
  const parentById = new Map<string, string | null>()
  const childrenById = new Map<string, string[]>()
  for (const p of parts) {
    parentById.set(p.id, p.parentId)
    if (!p.parentId) continue
    const siblings = childrenById.get(p.parentId)
    if (siblings) siblings.push(p.id)
    else childrenById.set(p.parentId, [p.id])
  }

  function ancestorIds(id: string): string[] {
    const ids: string[] = []
    for (let p = parentById.get(id); p; p = parentById.get(p)) ids.push(p)
    return ids
  }

  function subtreeIds(id: string): Set<string> {
    const ids = new Set<string>()
    const pending = [id]
    while (pending.length > 0) {
      const next = pending.pop()!
      if (ids.has(next)) continue
      ids.add(next)
      pending.push(...(childrenById.get(next) ?? []))
    }
    return ids
  }

  return { ancestorIds, subtreeIds }
}
